// extracted by mini-css-extract-plugin
export default {"container":"banner-faq_container__3qlNa","perguntas-faq":"banner-faq_perguntas-faq__SkQ3o"};